import { routes as authRoutes } from '@tyro/authentication/routes';
import type { TFunction } from '@tyro/i18n';
import { Router } from '@tyro/router/router';
import { Shell } from './components/shell';
import { getNavCategories } from './nav-categories';

const mockTFunction = ((key: string) => key) as TFunction<
  'navigation'[],
  undefined,
  'navigation'[]
>;

export function AppRouter() {
  return (
    <Router
      getNavCategories={() => getNavCategories(mockTFunction)}
      Shell={Shell}
      additionalRoutes={authRoutes}
    />
  );
}
